module.exports = __webpack_public_path__ + "img/transport_pic02.1c270d2c.png";